module.exports = __webpack_public_path__ + "img/refer-1.afe3e8ad.svg";